import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { BannerAppDownloads } from '../banner-app-downloads/banner-app-downloads';
import { Page } from '@core/services';

/**
 * Component that renders the section for downloading the mobile application.
 */
@Component({
  selector: 'app-section-download-app',
  imports: [LazyLoadImageModule, TranslateModule, BannerAppDownloads],
  templateUrl: './section-download-app.html',
  styleUrl: './section-download-app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionDownloadApp {
  /**
   * Service for handling page data.
   */
  private readonly page = inject(Page);

  /**
   * Signal containing the home page information.
   */
  protected readonly home = this.page.signalHome;

  /**
   * Opens the provided URL in a new browser tab.
   * @param url The URL to open.
   */
  protected goToUrl(url: string | undefined): void {
    if (!url) return;
    window.open(url);
  }
}
